import { useEffect, useRef } from "react";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/Marquee";
import { TrustBar } from "../components/landing/TrustBar";
import { Problem } from "../components/landing/Problem";
import { Services } from "../components/landing/Services";
import { HowItWorks } from "../components/landing/HowItWorks";
import { WhyUs } from "../components/landing/WhyUs";
import { SuccessStories } from "../components/landing/SuccessStories";
import { LeadCapture } from "../components/landing/LeadCapture";
import { FAQ } from "../components/landing/FAQ";
import { FinalCTA } from "../components/landing/FinalCTA";
import { track } from "../lib/api";

export default function LandingPage() {
  const fired = useRef(new Set());

  useEffect(() => {
    track("page_view", { page: "landing" });
    const thresholds = [25, 50, 75, 100];
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const pct = h > 0 ? Math.round((window.scrollY / h) * 100) : 0;
      thresholds.forEach((t) => {
        if (pct >= t && !fired.current.has(t)) {
          fired.current.add(t);
          track("scroll_depth", { depth: t });
        }
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <TrustBar />
      <Problem />
      <Services />
      <HowItWorks />
      <WhyUs />
      <SuccessStories />
      <LeadCapture />
      <FAQ />
      <FinalCTA />
    </main>
  );
}
